var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocPaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1948 7.38965H20.3896L15.6104 2.61035V1.80518C15.6104 1.59163 15.5255 1.38683 15.3745 1.23583C15.2235 1.08483 15.0187 1 14.8052 1C14.5916 1 14.3868 1.08483 14.2358 1.23583C14.0848 1.38683 14 1.59163 14 1.80518V7.04457C14.0005 7.56303 14.2067 8.0601 14.5733 8.42671C14.9399 8.79331 15.437 8.99949 15.9554 9H21.1948C21.4084 9 21.6132 8.91517 21.7642 8.76417C21.9152 8.61317 22 8.40837 22 8.19482C22 7.98128 21.9152 7.77648 21.7642 7.62548C21.6132 7.47448 21.4084 7.38965 21.1948 7.38965Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.54777V21.4522C4 22.1279 4.2731 22.776 4.75921 23.2538C5.24532 23.7316 5.90463 24 6.5921 24H19.4079C20.0954 24 20.7547 23.7316 21.2408 23.2538C21.7269 22.776 22 22.1279 22 21.4522V8.91498C22 8.37857 21.7845 7.86464 21.402 7.48863L15.3841 1.57364C15.01 1.20601 14.5065 1 13.9821 1H6.5921C5.90463 1 5.24532 1.26843 4.75921 1.74622C4.2731 2.22402 4 2.87206 4 3.54777Z",
    stroke: "#3D0E6B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocPaper);
export default __webpack_public_path__ + "static/media/ic_doc_paper.5c7fce66ffe888fe42dc0049ebf3eb15.svg";
export { ForwardRef as ReactComponent };